<soft-storage-location-search
  class="block mt-3"
  [storageLocation]="storageLocation()"
  (storageLocationChange)="resolve($event)"
  [idlagerstamm]="idlagerstamm()"
></soft-storage-location-search>

<div class="mt-3 flex items-center gap-3 w-full">
  <button class="soft-button primary !h-14 w-full" (click)="resolve(null)">
    Abbrechen
  </button>
</div>
